<template>
  <div class="select-offer-state dropdown-component">
    <div v-if="show" class="dropdown-component-select dropdown-component-select__top">
      <div class="dropdown-component-select__list">
        <div
          v-for="state in listStates"
          :key="state"
          class="dropdown-component-select__choice"
          @click="selectState(state)"
        >
          <div class="select-choice" :class="{ selected: currentState === state }">
            <p class="select-choice__name">
              {{ transchoice(`offer.state.${state}`, { count: 1 }) }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <button @click="setShow(!show)">
      <span class="dropdown-component-selected" :class="currentState">{{ placeholder }}</span>
      <span class="dropdown-component-selected--icon" />
    </button>
  </div>
</template>

<script>
import { translationMixin } from '@elements/translation';
import { OfficeStateEnum } from '@organisms/offer/office-state-enum';
import { eventBus } from '@tools/event-bus';

export default {
  mixins: [ translationMixin ],
  props: {
    offer: { type: Object, default: () => {} },
  },
  data() {
    return {
      show: false,
      currentState: this.offer.state,
      listStates: [
        OfficeStateEnum.PUBLISHED,
        OfficeStateEnum.UNPUBLISHED,
      ],
    };
  },
  computed: {
    placeholder() {
      return this.transchoice(`offer.state.${this.currentState}`, { count: 1 });
    },
  },
  mounted() {
    window.addEventListener('click', (event) => {
      const element = event.target.closest('.dropdown-component');
      if (!element) {
        // Click outside the dropdown should close the open dropdown
        this.show = false;
      }
    });
    eventBus.addEventListener('close-select-offer-state', () => {
      this.show = false;
    });
  },
  methods: {
    selectState(state) {
      this.currentState = state;
      this.$emit('change', { offer: this.offer, state });
      this.setShow(false);
    },
    setShow(value) {
      eventBus.dispatchEvent(new CustomEvent('close-select-offer-state'));
      this.show = value;
    },
  },
};
</script>
